import React from "react";

export default function ImageContentFeatureSection({
  title,
  paragraphs = [],
  image,
  imageAlt = "",
  reverse = false,
}) {
  if (!title || paragraphs.length === 0) return null;

  return (
    <section className="relative overflow-hidden bg-[#fffaf0] py-14 sm:py-16 lg:py-24">
      <style>
        {`
          @keyframes softFloat {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-14px); }
          }

          @keyframes shineMove {
            0% { transform: translateX(-140%) rotate(18deg); }
            100% { transform: translateX(180%) rotate(18deg); }
          }

          @keyframes fadeUp {
            from {
              opacity: 0;
              transform: translateY(22px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>

      <div className="pointer-events-none absolute left-[-240px] top-[-220px] h-[560px] w-[560px] rounded-full bg-[#f4d16b]/18 blur-3xl" />
      <div className="pointer-events-none absolute right-[-260px] bottom-[-240px] h-[600px] w-[600px] rounded-full bg-[#c89b2b]/12 blur-3xl" />

      <div className="relative mx-auto max-w-[1280px] px-5 sm:px-6 lg:px-10">
        <div
          className={`grid items-center gap-12 lg:gap-16 ${
            reverse
              ? "lg:grid-cols-[0.95fr_1.05fr]"
              : "lg:grid-cols-[1.05fr_0.95fr]"
          }`}
        >
          {/* CONTENT */}
          <div
            className={`${reverse ? "lg:order-2" : ""}`}
            style={{ animation: "fadeUp 0.8s ease-out both" }}
          >
            <div className="mb-6 flex items-center gap-4">
              <span className="h-[2px] w-16 rounded-full bg-[#c79211]" />
              <span className="h-2.5 w-2.5 rotate-45 bg-[#c79211]" />
            </div>

            <h2 className="max-w-[720px] text-[30px] font-extrabold leading-tight tracking-[-0.04em] text-[#06152f] sm:text-[42px] lg:text-[56px]">
              {title}
            </h2>

         <div className="mt-8 space-y-6">
  {paragraphs.map((paragraph, index) => (
    <p
      key={index}
      className="max-w-[720px] text-[17px] font-medium leading-8 text-[#334155] sm:text-[19px] sm:leading-9"
    >
      {paragraph}
    </p>
  ))}
</div>
          </div>

          {/* IMAGE */}
          <div
            className={`relative ${reverse ? "lg:order-1" : ""}`}
            style={{ animation: "softFloat 6s ease-in-out infinite" }}
          >
            <div className="relative mx-auto max-w-[520px]">
              <div className="absolute -inset-5 rounded-[42px] bg-gradient-to-br from-[#f4d16b]/35 via-white/40 to-[#c89b2b]/20 blur-2xl" />

              <div className="relative overflow-hidden rounded-[34px] border border-[#ead8a8] bg-white shadow-[0_28px_85px_rgba(20,33,61,0.12)]">
                <img
                  src={image}
                  alt={imageAlt}
                  className="h-[320px] w-full object-cover sm:h-[400px] lg:h-[470px]"
                />

                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#06152f]/30 via-transparent to-white/10" />

                <div
                  className="pointer-events-none absolute top-0 h-full w-[35%] bg-gradient-to-r from-transparent via-white/45 to-transparent blur-md"
                  style={{ animation: "shineMove 4.8s ease-in-out infinite" }}
                />
              </div>

              
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}